// 登录页
import { useState } from 'react';
import { Tabs } from 'antd';
import CodeLogin from './components/CodeLogin';
import AccountLogin from './components/AccountLogin';
import ChangeAccount from './components/ChangeAccount';
import styles from './index.module.less';
import { useMethods } from '@lhb/hook';
import IconFont from '@/common/components/IconFont';

const Login = ({ setDismissLogin }) => {
  const [initToken, setInitToken] = useState<string>();
  const [showAccountModal, setShowAccountModal] = useState<boolean>(false);
  const methods = useMethods({
    showChangeAccount(show: boolean, token?: string) {
      setInitToken(token);
      setShowAccountModal(show);
    }
  });
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.left}>
          <div className={styles.logo}>
            <IconFont iconHref='icon-logo' />
          </div>
          <div className={styles.mainImg}></div>
          <div className={styles.rightBottomImg}></div>
        </div>
        <div className={styles.right}>
          <div className={styles.rightTopImg}></div>
          <div className={styles.rightContent}>
            <p className={styles.title}></p>
            <p className={styles.tips}>Impress the real word</p>
            <Tabs
              defaultActiveKey='codeLogin'
              size='large'
              items={[
                { label: '验证码登录', key: 'codeLogin', children: <CodeLogin showChangeAccount={methods.showChangeAccount} /> },
                { label: '密码登录', key: 'accountLogin', children: <AccountLogin showChangeAccount={methods.showChangeAccount} setDismissLogin={setDismissLogin}/> }
              ]}
              tabBarGutter={48}
            />
          </div>
        </div>
      </div>

      <ChangeAccount
        initToken={initToken}
        showAccountModal={showAccountModal}
        showChangeAccount={methods.showChangeAccount}
      />
    </div>
  );
};

export default Login;
